module.exports = __webpack_public_path__ + "static/media/jinny-icon.fceee750.svg";